<template>
  <div class="kay-data-table">
    <div class="row">
      <div class="col-md-12">
        <div class="card">
          <div class="row">
            <div class="col-md-12">
              <div class="card-header">
                <h4 class="card-title">GAA 管理員</h4>
              </div>
              <div class="card-body">
                <!-- <router-link to="./gaa-users/new" type="success">
                  <n-button type="success">建立 GAA 管理員</n-button>
                </router-link>-->

                <el-row :gutter="20">

                  <!-- <el-col :span="10">
                    <el-select
                      v-model="filters[1].value"
                      placeholder="select type"
                      multiple="multiple"
                    >
                      <el-option label="Repair" value="repair"></el-option>
                      <el-option label="Help" value="help"></el-option>
                    </el-select>
                  </el-col>-->
                  <el-col :xs="24" :md="6">
                    <el-input v-model="filters[0].value" placeholder="搜尋 (ID,姓名或郵件)" prefix-icon="el-icon-search"></el-input>
                  </el-col>
                  <el-col :xs="24" :md="6">
                    <!-- 只有登入的人是管理員身份才可以建立管理員 -->
                    <router-link v-if="user.roleId === 1" to="./gaa-users/new" type="success">
                      <el-button type="success" plain>建立 GAA 管理員</el-button> 
                    </router-link>
                    <!-- 否則顯示提醒文字，說明只有管理員以及type是gaa才能建立管理員 -->
                    <p v-else-if="user.roleId !== 1 && user.type === 'gaa'">只有管理員才能增加GAA帳號</p>
                  </el-col>
                </el-row>

                <data-tables :data="data" :filters="filters" >
                  <el-table-column
                    v-for="title in titles"
                    :prop="title.prop"
                    :label="title.label"
                    :key="title.prop"
                    sortable="custom"
                  >
                  </el-table-column>
                  <el-table-column label="操作" prop="isDisabled">
                  <template slot-scope="scope">
                    <el-button v-if="user.roleId === 1" :type="'default'" :icon="'el-icon-edit'" @click="handlerToEdit(scope.row)">
                      {{ '更新帳密' }}
                    </el-button>
<!--                    只有現在登入的人是管理員才看得到刪除帳號, user.roleId === 1 -->
                    <el-button v-if="user.roleId === 1" :type="scope.row.isDisabled ? 'success' : 'danger'" :icon="'el-icon-connection'" @click="toggleIsDisabled(scope.row)">
                      {{ scope.row.isDisabled ? '啟用帳號' : '刪除帳號' }}
                    <!-- <el-button :type="scope.row.isDisabled ? 'success' : 'danger'" :icon="'el-icon-connection'" @click="toggleIsDisabled(scope.row)"> -->
                      <!-- {{ scope.row.isDisabled ? '啟用帳號' : '刪除帳號' }} -->
                    </el-button>
                  </template>
                </el-table-column>
                </data-tables>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import { json } from "d3";
import moment from "moment";

export default {
  data() {
    return {
      data: [],
      editPhone: '',
      titles: [
        {
          prop: "id",
          label: "NO."
        },
        {
          prop: "email",
          label: "Email"
        },
        {
          prop: "name",
          label: "Name"
        },
        {
          prop: "createdAt",
          label: "建立時間"
        },
        {
          prop: "updatedAt",
          label: "更新時間"
        }
      ],
      filters: [
        {
          value: "",
          prop: ["id", "name", "email"]
        },
        {
          value: []
        }
      ]
    };
  },
  methods: {
    handleClick(command) {
      this.$message(`click dropdown button ${command}`);
    },
    handlerToEdit(row) {
      this.$router.push(`/gaa-users/${row.id}/edit`);
    },
    getGaaUsers() {
      return axios
        .get(`${process.env.VUE_APP_APIHOST}/gaa/gaa-users`)
        .then(response => {
          this.data = response.data;
          for (let a of this.data) {
            a.createdAt = moment
              .unix(a.createdTs)
              .format("YYYY-MM-DD HH:mm:ss Z");
            a.updatedAt = moment
              .unix(a.updatedTs)
              .format("YYYY-MM-DD HH:mm:ss Z");
          }
          console.log(response.data)
          return response.data;
        });
    },
    toggleIsDisabled(row){
      row.isDisabled = !row.isDisabled
      return axios
      .put(`${process.env.VUE_APP_APIHOST}/gaa/gaa-users/${row.id}/lock`,
        row
      )
      .then(response => {
        console.log(response)

        this.getGaaUsers();
      })
      .catch (e => {
        console.error('Error', e);
      })
    }
  },
  computed: {
    user: function() {
      return this.$store.getters.user;
    }
  },
  mounted() {
    this.getGaaUsers();
  }
};
</script>
<style scoped>
.kay-data-table .btn-base,
.el-select .el-input .el-input__inner,
.btn,
.navbar .navbar-nav > a.btn {
  margin: 0px !important;
}
</style>
